import React from 'react';
import "./usersList.css"
import UsersData from './usersData';

const UsersList = (props) => {
    return ( 
        <>
            <div className="mainUsersList">
                <h1 className="usersTitle">Lista Uzytkowników</h1>
                <UsersData 
                    usersList={props.usersList}
                    handleDeleteUser={props.handleDeleteUser}
                />
            </div>
        </>
     );
}
 
export default UsersList;